// 引入富文本
import EditorBar from '@/components/wangeditor/wangeditor.vue'
export default {
  data() {
    return {
      // 搜索关键字
      keywordName: '',
      // 项目包数据
      tableData: [],
      // 总条数
      total: 0,
      // 当前页
      currentPage: 1,
      // 每页显示条数
      pageSize: 15,
      // 项目包id
      package_id: null,
      // 新闻数据
      newsList: [],
      // 新闻id
      newsId: null,
      // 新闻对象
      news: {},
      // 新闻内容
      newsContent: '',
      // 新闻标题
      newsTitle: '',
      // 新闻url
      newsUrl: '',
      // 新闻内容
      configNews: '',
      // 控制显示新闻中心弹窗
      showNews: false,
      // 控制显示发布新闻的弹窗
      showAddNews: false,
      // 控制显示编辑新闻的弹窗
      showEditNews: false,
      // 表单域标签的宽度
      formLabelWidth: '60px',
      // 上传文件的路径
      action: this.baseUrl + 'file/upload_file?token=' + this.$store.state.authority_management,
    }
  },
  methods: {

    // 显示新闻中心弹窗
    showNewsDialog(data) {
      // 显示新闻弹窗
      this.showNews = true
      // 取出package_id
      this.package_id = data.id
      // 获取当前项目包的新闻数据
      this.getNewsData()
    },

    // 发布新闻
    showAddNoticeDialog() {
      // 显示发布新闻弹窗
      this.showAddNews = true
    },

    // 获取新闻数据
    getNewsData() {
      this.$post('product_news/search', {
        offset: 0,
        length: 999,
        package_id: this.package_id
      }).then(res => {
        if (res.status === 200) {
          this.newsList = res.data.result.data
        }
      })
    },

    // 显示编辑新闻的弹窗
    showEditNewsDialog(data) {
      this.newsId = data.id
      this.showEditNews = true
      this.getNewsById()
    },

    // 根据id获取一则新闻
    getNewsById() {
      this.$post('product_news/news', {
        token: this.$store.state.authority_management,
        id: this.newsId
      }).then(res => {
        if (res.status === 200) {
          this.news = res.data.result
          this.newsContent = res.data.result.content
        }
      })
    },

    // 删除一则新闻
    deleteNews(data) {
      this.$confirm('此操作将删除该新闻, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post('product_news/delete', {
          token: this.$store.state.authority_management,
          id: data.id
        }).then(res => {
          if (res.status === 200) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            // 重新获取新闻数据
            this.getNewsData()
          } else {
            this.$message({
              type: 'error',
              message: '删除失败'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },

    // 添加一则新闻
    addNews() {
      if (this.configNews === '') {
        this.$message({
          type: 'error',
          message: '请先保存'
        })
        return
      }
      this.$post('product_news/insert', {
        token: this.$store.state.authority_management,
        package_id: this.package_id,
        title: this.newsTitle,
        content: this.configNews,
        url: this.newsUrl,
        type: 0
      }).then(res => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: '添加成功'
          })
          // 重新获取新闻列表
          this.getNewsData()
          this.showAddNews = false
        } else {
          this.$message({
            type: 'error',
            message: '添加失败'
          })
        }
      })
    },

    // 更新一则新闻
    updateNews() {
      this.$post('product_news/update', {
        token: this.$store.state.authority_management,
        id: this.newsId,
        title: this.news.title,
        url: this.news.url,
        content: this.configNews
      }).then(res => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: '更新成功'
          })
          // 重新获取新闻列表
          this.getNewsData()
          this.showEditNews = false
        } else {
          this.$message({
            type: 'error',
            message: '更新失败'
          })
        }
      })
    },

    // 富文本保存数据
    showMessageFromChild(data) {
      this.configNews = data
    },

    // 搜索项目包
    onSearch() {
      this.$post('package/shop_search', {
        token: this.$store.state.authority_management,
        offset: 0,
        length: this.pageSize,
        name: this.keywordName,
        shop_id: this.$store.state.store.id
      }).then(res => {
		  this.currentPage = 1
        if (res.status === 200) {
          this.tableData = res.data.result.data
          this.total = res.data.result.total
        }
      })
    },

    // 查找项目包
    searchPackage(name = '') {
      this.$post('package/shop_search', {
        token: this.$store.state.authority_management,
        offset: (this.currentPage - 1) * this.pageSize,
        length: this.pageSize,
        name: this.keywordName,
        shop_id: this.$store.state.store.id
      }).then(res => {
		  
        if (res.status === 200) {
          this.tableData = res.data.result.data
          this.total = res.data.result.total
        }
      })
    },

    // 当前页显示条数改变时调用
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.searchPackage()
    },

    // 当前页改变时调用
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.searchPackage()
    },

    // 上传文件之前验证文件类型
    beforeUpload(file) {
      let name = file.name

      // 判断文件类型
      let type = name.split('.')[1]

      const isPDF = type === 'pdf'
      const isDOC = type === 'doc'
      const isDOCX = type === 'docx'

      if (!isPDF && !isDOC && !isDOCX) {
        this.$message.error('上传文件只能是 PDF, DOC, DOCX格式!')
        return false
      }

      return true
    },

    // 覆盖上传
    uploadFile(q) {
      this.$upload(this.action, q).then(res => {
        this.$post('product_news/insert', {
          token: this.$store.state.authority_management,
          package_id: this.package_id,
          name: q.file.name.split('.')[0],
          data: res.data.result,
          type: 1
        }).then(res => {
          this.$message({
            message: '上传文件新闻成功',
            type: 'success'
          })
          this.getNewsData()
        })

      }).catch(err => {
        this.$message.error('上传失败，请重试！')
      })
    }
  },
  components: {
    EditorBar
  },
  mounted() {
    this.searchPackage()
  },
}